<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
      :color="this.$primaryColor"
    ></loading>
    <p class="text-center font-bold">
      Add people to the biometric gallery and perform identification through
      facial recognition
    </p>
    <div class="mt-6 lg:flex justify-around lg:space-x-4 space-x-0">
      <div>
        <div>
          <p class="font-bold text-xl mb-2">Identify person</p>
          <div class="w-24">
            <label
              for="minScore"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Minimum score
            </label>
            <input
              id="minScore"
              v-model="minScore"
              type="number"
              name="minScore"
              step="0.01"
              required
              class="w-full mt-1"
              @change="scoreBetween"
            />
            <div class="error" v-if="errors.minScore">
              {{ errors.minScore }}
            </div>
          </div>
          <div class="mt-2">
            <label
              for="image1"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Query face image
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="image1"
                type="file"
                name="image1"
                accept="image/*"
                required
                class="w-full"
                @change="assingImgInput"
              />
            </div>
            <div class="error" v-if="errors.image1">
              {{ errors.image1 }}
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            class="
              justify-center
              cursor-pointer
              inline-flex
              px-4
              py-2
              text-base
              transition
              duration-150
              ease-in-out
              border border-gray-600
              rounded-md
              mt-3
            "
            @click="takePhoto(1)"
          >
            Or Take Photo
          </button>
          <img :src="img1" class="max-w-xs max-h-full mt-3 mx-auto" />
        </div>
        <div class="text-center mt-6">
          <button class="btn-primary" @click="identify()">Identify</button>
        </div>

        <div class="mt-6" v-if="identifyResult">
          <div class="border border-emerald-500 text-center p-4 rounded-xl bg-emerald-50" v-if="identifyResult.length > 0">
            <p class="font-bold text-lg mb-2">
              Person identified: {{ identifyResult[0].template_id }}
            </p>
            <p>
              The matching score is {{ identifyResult[0].score.toFixed(2) }}
            </p>
          </div>
          <div class="border border-red-500 text-center p-4 rounded-xl bg-red-50" v-else>
            <p class="font-bold text-lg mb-2">Person not found.</p>
            <p>There are no candidates for the provided image.</p>
          </div>
        </div>
      </div>
      <div>
        <div>
          <p class="font-bold text-xl mb-2 lg:mt-0 mt-4">Gallery Management</p>
          <div class="w-32">
            <label
              for="personID"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Person ID
            </label>
            <input
              id="personID"
              v-model="personID"
              type="text"
              name="personID"
              required
              class="w-full mt-1"
            />
            <div class="error" v-if="errors.personID">
              {{ errors.personID }}
            </div>
          </div>
          <div class="mt-2">
            <label
              for="image2"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Gallery face image
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="image2"
                type="file"
                name="image2"
                accept="image/*"
                required
                class="w-full"
                @change="assingImgInput"
              />
            </div>
            <div class="error" v-if="errors.image2">
              {{ errors.image2 }}
            </div>
          </div>

          <div class="text-center">
            <button
              class="
                justify-center
                cursor-pointer
                inline-flex
                px-4
                py-2
                text-base
                transition
                duration-150
                ease-in-out
                border border-gray-600
                rounded-md
                mt-3
              "
              @click="takePhoto(2)"
            >
              Or Take Photo
            </button>
            <img :src="img2" class="max-w-xs max-h-full mt-3 mx-auto" />
          </div>
          <div class="text-center mt-6">
            <button class="btn-primary" @click="addToGallery()">
              Add to Gallery
            </button>
          </div>

          <div
            class="mt-6 border border-gray-200 rounded-lg"
            v-if="galleryPersonsId.length > 0"
          >
            <table
              class="
                min-w-full
                overflow-hidden
                divide-y divide-gray-200
                rounded-lg
              "
            >
              <thead>
                <tr
                  class="
                    text-xs
                    font-medium
                    text-left text-gray-500
                    uppercase
                    bg-gray-100
                  "
                >
                  <th class="px-6 py-3 table-cell">
                    yk_face_api gallery
                  </th>
                  <th class="px-6 py-3 table-cell text-right">
                    <div
                      class="
                        justify-center
                        cursor-pointer
                        inline-flex
                        px-2
                        py-2
                        text-sm text-white
                        transition
                        duration-150
                        ease-in-out
                        rounded-md
                        bg-red-500
                        hover:bg-red-600
                      "
                      @click="deleteAllFromGallery()"
                    >
                      Delete all
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :class="index % 2 == 0 ? 'bg-gray-50' : 'bg-gray-100'"
                  v-for="(r, index) in galleryPersonsId"
                  :key="index"
                  class="table-row sm:border-0 border-b border-gray-200"
                >
                  <td
                    class="
                      px-6
                      py-4
                      text-xs text-left text-gray-500
                      uppercase
                      align-middle
                    "
                  >
                    {{ r }}
                  </td>
                  <td
                    class="
                      px-6
                      py-4
                      text-xs
                      font-medium
                      border-r border-gray-200
                      text-right
                      uppercase
                      align-middle
                      text-red-500
                    "
                  >
                    <TrashIcon
                      class="inline-block w-4 cursor-pointer"
                      @click="deleteTemplateFromGallery(r)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <modal :show="showWebCam" @closeModal="closeModal()">
      <webcam :showCam="showWebCam" @img="setImg" />
    </modal>
  </div>
</template>

<script>
import webcam from "../../Components/webCam.vue";
import modal from "../../Components/modal.vue";
import { TrashIcon } from "@vue-hero-icons/outline";
export default {
  components: { webcam, modal, TrashIcon },
  props: ["option"],
  data() {
    return {
      errors: {
        image1: null,
        image2: null,
        personID: null,
        minScore: null,
      },
      showWebCam: false,
      openImage: null,
      img1: null,
      img2: null,
      loading: false,
      personID: null,
      minScore: "0.6",
      galleryPersonsId: [],
      identifyResult: null,
    };
  },
  created() {
    this.getGallery();
  },
  methods: {
    takePhoto(num) {
      this.openImage = num;
      this.showWebCam = true;
    },
    closeModal() {
      this.openImage = null;
      this.showWebCam = false;
    },
    setImg(img) {
      if (this.openImage == 1) {
        this.img1 = img;
        this.errors.image1 = null;
      } else {
        this.img2 = img;
        this.errors.image2 = null;
      }
      this.showWebCam = false;
    },
    identify() {
      this.errors.image1 = null;
      this.errors.minScore = null;
      if (this.img1 == null) {
        this.errors.image1 = "Image required";
      }
      if (this.minScore == null || this.minScore == "") {
        this.errors.minScore = "Field required";
      }
      if (this.errors.image1 != null || this.errors.minScore != null) {
        return;
      }

      this.loading = true;
      this.axios
        .post("/user/api/face/identify", {
          img1: this.img1,
          minScore: this.minScore,
          option: this.option,
        })
        .then((response) => {
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
          } else {
            this.identifyResult = response.data;
          }
        })
        .catch((e) => {
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addToGallery() {
      this.errors.image2 = null;
      this.errors.personID = null;
      if (this.img2 == null) {
        this.errors.image2 = "Image required";
      }
      if (this.personID == null || this.personID == "") {
        this.errors.personID = "Field required";
      }
      if (this.errors.image2 != null || this.errors.personID != null) {
        return;
      }

      this.loading = true;
      this.axios
        .post("/user/api/face/add-person-to-gallery", {
          img1: this.img2,
          personID: this.personID,
        })
        .then((response) => {
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
            if (response.data.message_type == "success") {
              this.galleryPersonsId.push(this.personID);
            }
          }
        })
        .catch((e) => {
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getGallery() {
      this.loading = true;
      this.axios
        .get("/user/api/face/get-gallery")
        .then((response) => {
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
          } else {
            this.galleryPersonsId = response.data;
          }
        })
        .catch((e) => {
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteAllFromGallery() {
      this.loading = true;
      this.axios
        .post("/user/api/face/delete-gallery")
        .then((response) => {
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
            if (response.data.message_type == "success") {
              this.galleryPersonsId = [];
            }
          }
        })
        .catch((e) => {
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteTemplateFromGallery(personId) {
      this.loading = true;
      this.axios
        .post("/user/api/face/delete-template-gallery", {
          personId: personId,
        })
        .then((response) => {
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
            if (response.data.message_type == "success") {
              this.galleryPersonsId = this.galleryPersonsId.filter(
                (item) => item !== personId
              );
            }
          }
        })
        .catch((e) => {
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async assingImgInput(event) {
      this.openImage = event.target.id == "image1" ? 1 : 2;
      let imgBase64 = await this.getBase64(event.target.files[0]);
      this.setImg(imgBase64);
      this.openImage = null;
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    scoreBetween() {
      this.minScore =
        this.minScore > 1 ? 1 : this.minScore < 0 ? 0 : this.minScore;
    },
  },
};
</script>
